import { ApiParams, ApiResponse } from '@models/api.model.ts';
import { ProductsModel } from '@models/products.model.ts';
import axiosInstance from '@api/axios-instance.ts';

export const getProducts = async (
  params?: ApiParams
): Promise<ApiResponse<ProductsModel>> => {
  const response = await axiosInstance.get('/pms/inventory/getter', { params });
  return response.data;
};

export const getAllProducts = async (): Promise<ProductsModel[]> => {
  const response = await axiosInstance.get('/pms/inventory/all');
  return response.data;
};

export const getInventoryCategories = async (): Promise<any[]> => {
  const response = await axiosInstance.get('/pms/inventory-categories');
  return response.data;
};

export const createProduct = async (body: any): Promise<ProductsModel> => {
  return await axiosInstance.post(`/pms/inventory`, body);
};

export const editProduct = async (
  body: any,
  id: number
): Promise<ProductsModel> => {
  return await axiosInstance.put(`/pms/inventory/${id}`, body);
};

export const deleteProduct = async (id: number): Promise<void> => {
  return await axiosInstance.delete(`/pms/inventory/${id}`);
};

export const togglePublish = async (id: number): Promise<any> => {
  const response = await axiosInstance.put(`/pms/inventory/toggle/${id}`);
  return response.data;
};
